import React from 'react'

const SearchIcon: React.FC = () => (
	<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="none" viewBox="0 0 22 22">
		<path
			fill="#030A7E"
			className="fill-brand-yellow-light"
			fillRule="evenodd"
			d="M21.514 19.155l-4.325-4.276c1.127-1.575 1.768-3.518 1.768-5.446C18.957 4.237 14.672 0 9.415 0 4.2 0 0 4.32 0 9.559c0 5.196 4.286 9.433 9.542 9.433 1.95 0 3.915-.634 5.509-1.748l4.324 4.275c.265.262.709.481 1.07.481.475 0 .743-.159 1.069-.48.264-.262.486-.7.486-1.058l-.04-.248a4.317 4.317 0 01-.11-.412c-.071-.28-.147-.46-.336-.647zM9.35 16.5c4.014 0 7.15-3.261 7.15-7.15 0-4.014-3.136-7.15-7.15-7.15S2.2 5.461 2.2 9.35c0 4.014 3.261 7.15 7.15 7.15z"
			clipRule="evenodd"
		/>
	</svg>
)

export default SearchIcon
